module.exports = __webpack_public_path__ + "static/contact-lg-c390a9ee03fb3bb74a559dfa9f0ed002.jpg";